import { IWebsiteBuilderFlex, websiteBuilderGenerateFlexDesignStyles } from "pages/secure/facility/websiteBuilder/editor/nodes/container/websiteBuilderFlex";
import React, { ReactNode } from "react";

interface IWebsiteBuilderFlexViewProps {
  node: IWebsiteBuilderFlex;
  children: ReactNode;
}

export function WebsiteBuilderFlexView(props: IWebsiteBuilderFlexViewProps) {
  const { node, children } = props;

  const settings = node.container.settings;
  const designStyles = websiteBuilderGenerateFlexDesignStyles(settings);

  return (
    <div
      className={designStyles.className}
      style={designStyles.styleProperties}
    >
      {children}
    </div>
  );
}